// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'

// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
// Sentry.init({
//   dsn: 'https://4a2ee0549caf4329a1a3db67e3647af4@sentry.io/1441920',
//   integrations: [
//     new Integrations.Vue({
//       Vue,
//       attachProps: true
//     })
//   ]
// })

// vuetify
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'
// Vue.use(Vuetify)

import draggable from 'vuedraggable'
Vue.component('draggable', draggable)

// font-awesome
require('font-awesome/css/font-awesome.css')

import { Multipane, MultipaneResizer } from 'vue-multipane'
Vue.component('multipane', Multipane)
Vue.component('multipane-resizer', MultipaneResizer)

// vue-ripple
import Ripple from 'vue-ripple-directive'
Vue.directive('ripple', Ripple)
// Ripple.color = 'rgba(255, 255, 255, 0.35)'
Ripple.zIndex = 55

// vue-lottie
import Lottie from 'vue-lottie'
Vue.component('lottie', Lottie)

// Multiselect
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// vuejs-datepicker
import Datepicker from 'vuejs-datepicker'
Vue.component('datepicker', Datepicker)

// vue-color
import { Chrome, Compact, Swatches, Material, Slider } from 'vue-color'
Vue.component('chrome-picker', Chrome)
Vue.component('compact-picker', Compact)
Vue.component('swatches-picker', Swatches)
Vue.component('material-picker', Material)
Vue.component('slider-picker', Slider)

// components/layout/
import SecItem from '@/components/layout/SecItem.vue'
Vue.component('section-item', SecItem)
import SecNavi from '@/components/layout/SecNavi.vue'
Vue.component('section-navi', SecNavi)

// components/layout/common/
import TopNavi from '@/components/layout/common/TopNavi.vue'
Vue.component('component-topnavi', TopNavi)
import Header from '@/components/layout/common/Header.vue'
Vue.component('component-header', Header)
import Menu from '@/components/layout/common/Menu.vue'
Vue.component('component-menu', Menu)
import Footer from '@/components/layout/common/Footer.vue'
Vue.component('component-footer', Footer)

// components/modules/History/
import History from '@/components/modules/History/History.vue'
Vue.component('modal-history', History)

// components/modules/Form/
import LogIn from '@/components/modules/Form/LogIn.vue'
Vue.component('login-modal', LogIn)
import UserForm from '@/components/modules/Form/UserForm.vue'
Vue.component('user-form', UserForm)
import FamilyForm from '@/components/modules/Form/FamilyForm.vue'
Vue.component('family-form', FamilyForm)
import StudentForm from '@/components/modules/Form/StudentForm.vue'
Vue.component('student-form', StudentForm)
import TutorForm from '@/components/modules/Form/TutorForm.vue'
Vue.component('tutor-form', TutorForm)
import AppointmentForm from '@/components/modules/Form/AppointmentForm.vue'
Vue.component('appointment-form', AppointmentForm)
import AgreementForm from '@/components/modules/Form/AgreementForm.vue'
Vue.component('agreement-form', AgreementForm)

// components/modules/Humanlist/
import HumanList from '@/components/modules/HumanList/HumanList.vue'
Vue.component('humanlist', HumanList)

// components/modules/Profile/
import AppointmentProfile from '@/components/modules/Profile/AppointmentProfile.vue'
Vue.component('appointment-profile', AppointmentProfile)
import AppointmentProfile2 from '@/components/modules/Profile/AppointmentProfile2.vue'
Vue.component('appointment-profile2', AppointmentProfile2)
import FamilyProfile from '@/components/modules/Profile/FamilyProfile.vue'
Vue.component('family-profile', FamilyProfile)
import StudentProfile from '@/components/modules/Profile/StudentProfile.vue'
Vue.component('student-profile', StudentProfile)
import TutorProfile from '@/components/modules/Profile/TutorProfile.vue'
Vue.component('tutor-profile', TutorProfile)
import TutorProfile2 from '@/components/modules/Profile/TutorProfile2.vue'
Vue.component('tutor-profile2', TutorProfile2)
import AgreementProfile from '@/components/modules/Profile/AgreementProfile.vue'
Vue.component('agreement-profile', AgreementProfile)

// components/modules/Searcdh/
import Search from '@/components/modules/Search/Search.vue'
Vue.component('search', Search)

// components/modules/Table/
import TableCell from '@/components/modules/Table/TableCell.vue'
Vue.component('table-c', TableCell)
import TrCell from '@/components/modules/Table/TrCell.vue'
Vue.component('tr-c', TrCell)
import ThCell from '@/components/modules/Table/ThCell.vue'
Vue.component('th-c', ThCell)
import TdCell from '@/components/modules/Table/TdCell.vue'
Vue.component('td-c', TdCell)

// components/util/
import Button from '@/components/util/Button.vue'
Vue.component('btn', Button)
import HighLight from '@/components/util/HighLight.vue'
Vue.component('component-hightlight', HighLight)
import Modal from '@/components/util/Modal.vue'
Vue.component('component-modal', Modal)
import ExportModal from '@/components/util/ExportModal.vue'
Vue.component('export-modal', ExportModal)
import TAG from '@/components/util/Tag.vue'
Vue.component('tag', TAG)
import Loading from '@/components/util/Loading.vue'
Vue.component('loading', Loading)

// components/Pages/Appointment
import AppointmentFamily from '@/components/Pages/Appointment/AppointmentFamily.vue'
Vue.component('appointment-family', AppointmentFamily)
import AppointmentHistory from '@/components/Pages/Appointment/AppointmentHistory.vue'
Vue.component('appointment-history', AppointmentHistory)
import AppointmentHistory2 from '@/components/Pages/Appointment/AppointmentHistory2.vue'
Vue.component('appointment-history2', AppointmentHistory2)
import AppointmentMap2 from '@/components/Pages/Appointment/AppointmentMap2.vue'
Vue.component('appointment-map2', AppointmentMap2)
import AppointmentCard from '@/components/Pages/Appointment/AppointmentCard.vue'
Vue.component('appointment-card', AppointmentCard)
import AppointmentFamilyModal from '@/components/Pages/Appointment/AppointmentFamilyModal.vue'
Vue.component('appointment-family-modal', AppointmentFamilyModal)
import AppointmentGmail from '@/components/Pages/Appointment/AppointmentGmail.vue'
Vue.component('appointment-gmail', AppointmentGmail)
import AppointmentGmailSupport from '@/components/Pages/Appointment/AppointmentGmailSupport.vue'
Vue.component('appointment-gmail-support', AppointmentGmailSupport)

// components/Pages/Appointments
import AppointmentsModal from '@/components/Pages/Appointments/AppointmentsModal.vue'
Vue.component('appointments-modal', AppointmentsModal)

// components/Pages/Family
import FamilyStudentsIndex from '@/components/Pages/Family/FamilyStudentsIndex.vue'
Vue.component('family-students-index', FamilyStudentsIndex)
import FamilyHistory from '@/components/Pages/Family/FamilyHistory.vue'
Vue.component('family-history', FamilyHistory)
import FamilyStudentsModal from '@/components/Pages/Family/FamilyStudentsModal.vue'
Vue.component('family-students-modal', FamilyStudentsModal)
import FamilyGmailSupport from '@/components/Pages/Family/FamilyGmailSupport.vue'
Vue.component('family-gmail-support', FamilyGmailSupport)

// components/Pages/Student
import StudentTutorsIndex from '@/components/Pages/Student/StudentTutorsIndex.vue'
Vue.component('student-tutors-index', StudentTutorsIndex)
import StudentHistory from '@/components/Pages/Student/StudentHistory.vue'
Vue.component('student-history', StudentHistory)
import StudentTutorsModal from '@/components/Pages/Student/StudentTutorsModal.vue'
Vue.component('student-tutors-modal', StudentTutorsModal)
import StudentTutorsModalEdit from '@/components/Pages/Student/StudentTutorsModalEdit.vue'
Vue.component('student-tutors-modal-edit', StudentTutorsModalEdit)

// components/Pages/Tutor
import TutorStudentsIndex from '@/components/Pages/Tutor/TutorStudentsIndex.vue'
Vue.component('tutor-students-index', TutorStudentsIndex)
import TutorStudent2 from '@/components/Pages/Tutor/TutorStudent2.vue'
Vue.component('tutor-student2', TutorStudent2)
import TutorHistory from '@/components/Pages/Tutor/TutorHistory.vue'
Vue.component('tutor-history', TutorHistory)
import TutorHistory2 from '@/components/Pages/Tutor/TutorHistory2.vue'
Vue.component('tutor-history2', TutorHistory2)
import TutorMap2 from '@/components/Pages/Tutor/TutorMap2.vue'
Vue.component('tutor-map2', TutorMap2)
import TutorMedium from '@/components/Pages/Tutor/TutorMedium.vue'
Vue.component('tutor-medium', TutorMedium)
import TutorMedium2 from '@/components/Pages/Tutor/TutorMedium2.vue'
Vue.component('tutor-medium2', TutorMedium2)
import TutorFile from '@/components/Pages/Tutor/TutorfileView.vue'
Vue.component('tutor-file', TutorFile)
import TutorFile2 from '@/components/Pages/Tutor/TutorfileView2.vue'
Vue.component('tutor-file2', TutorFile2)
import TutorStudentsModal from '@/components/Pages/Tutor/TutorStudentsModal.vue'
Vue.component('tutor-students-modal', TutorStudentsModal)
import TutorStudentsModalEdit from '@/components/Pages/Tutor/TutorStudentsModalEdit.vue'
Vue.component('tutor-students-modal-edit', TutorStudentsModalEdit)
import TutorModal from '@/components/Pages/Tutor/TutorModal.vue'
Vue.component('tutor-modal', TutorModal)

// component/Pages/Student_tutors
import Student_tutorsModal from '@/components/Pages/Student_tutors/Student_tutorsModal.vue'
Vue.component('student-tutors-modal', Student_tutorsModal)
import Student_tutorsAdd from '@/components/Pages/Student_tutors/Student_tutorsAdd.vue'
Vue.component('student-tutors-add', Student_tutorsAdd)
import ElapsedComponent from '@/components/util/elapsed.vue'
Vue.component('elapsed-component', ElapsedComponent)

// components/Pages/Agreement
import AgreementHistory from '@/components/Pages/Agreement/AgreementHistory.vue'
Vue.component('agreement-history', AgreementHistory)
import AgreementsBank from '@/components/Pages/Agreements/AgreementsBank.vue'
Vue.component('agreements-bank', AgreementsBank)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js